/**
 * Site Group Settings V2 — "Contacts" section: presence-only mount
 * of the legacy `SiteGroupContactsTab`.
 *
 * Contains:
 * - ContactsSection (default export)
 */

import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import React from 'react';
import { useTranslation } from 'react-i18next';

import StatusChip from '@sophocles/components/StatusChip';
import { SettingsSection } from '@sophocles/views/settings/components';
import SiteGroupContactsTab from '@sophocles/views/settings/components/SiteGroupContactsTab';

// Contacts section.  Drops the existing SiteGroupContactsTab —
// itself a thin wrapper around ContactManagementView — so the V2
// surface stays in lock-step with legacy.  ContactManagementView
// owns its own CRUD flow against SiteGroupContact / customer
// contacts; the consolidated PATCH never writes here (presence-only
// marker, same idiom as Sharing).
//
// Visibility predicate is verbatim: `is_staff` on the legacy
// `getSections`.  Backend gates section presence; we render based
// on `settings.contacts` being present.
export default function ContactsSection({ customerId, siteGroupId }) {
  const { t } = useTranslation();
  const staffChip = <StatusChip color="info" label={t('siteSettings.staffOnly', 'Staff Only')} />;
  return (
    <SettingsSection
      id="settings-contacts"
      icon={<ContactPhoneIcon />}
      title={t('siteGroupSettings.v2.contacts', 'Contacts')}
      description={t(
        'siteGroupSettings.v2.contactsDescription',
        'Contact information for this group. Customer-level contacts can be toggled on inside.',
      )}
      chip={staffChip}
    >
      <SiteGroupContactsTab customerId={customerId} siteGroupId={siteGroupId} />
    </SettingsSection>
  );
}
